import React from 'react';
import TableRow from '@mui/material/TableRow';
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import TableCell from '@mui/material/TableCell';
import Typography from '@mui/material/Typography';
import '../../../Static/Master/firmtable.css';
import { useDispatch } from 'react-redux';
import { toast, ToastContainer } from 'react-toastify';
import { fetchTransportBailData, sendTransportBailWhatsappMsg } from '../../../Store/PHPSlice/Transport/transportBail';

const TableBody2 = ({
    id,
    transportNm,
    partyNm,
    partycontact,
    lrno,
    totalbail,
    dt,
    w_msg_sts,
    serialNumber,
    selected,
    handleClick,
}) => {

    const dispatch = useDispatch();

    // ⭐ WhatsApp Send Function
    const handleSendMsg = (id) => {

        const isConfirmed = window.confirm("Do you want to send WhatsApp message?");
        if (!isConfirmed) return;

        dispatch(sendTransportBailWhatsappMsg(id))
            .unwrap()
            .then((res) => {
                //  console.log("API Response =>", res.msg);  // <-- NOW WORKS
                if (res.msg === "Message Sent") { }
                alert("Whatsapp Message Send Message Successfully");
                dispatch(fetchTransportBailData());

                window.location.reload();

            })
            .catch(() => {
                toast.error("Failed to send message");
            });
    };



    return (
        <>
            <TableRow hover tabIndex={-1} role="checkbox" selected={selected}>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align="center">{serialNumber}</TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align="center">
                    <Typography variant="subtitle2" noWrap>
                        {dt}
                    </Typography>
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align="center">{partyNm}</TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align="center">{partycontact}</TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align="center">{transportNm}</TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align="center">{lrno}</TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align="center">{totalbail}</TableCell>

                {/* ⭐ WhatsApp ICON with ID click */}
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align="center">
                    <WhatsAppIcon
                        onClick={() => handleSendMsg(id)}
                        style={{
                            color: "green",
                            fontSize: 28,
                            cursor: "pointer",
                        }}
                    />
                </TableCell>

                {/* ⭐ Status Color */}
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align="center">

                    {w_msg_sts === "1" ? (
                        <button
                            style={{
                                backgroundColor: "green",
                                color: "white",
                                padding: "4px 12px",
                                border: "none",
                                borderRadius: "4px",
                                fontWeight: "bold",
                                cursor: "default"
                            }}
                        >
                            Sent
                        </button>
                    ) : (
                        <button
                            style={{
                                backgroundColor: "red",
                                color: "white",
                                padding: "4px 12px",
                                border: "none",
                                borderRadius: "4px",
                                fontWeight: "bold",
                                cursor: "default"
                            }}
                        >
                            Pending
                        </button>
                    )}
                </TableCell>
            </TableRow>

            <ToastContainer />
        </>
    );
};

export default TableBody2;
